export const VARIATIONS_LIST_PER_PAGE = '_VARIATIONS_LIST_PER_PAGE'
export const CREATIVES_LIST_PER_PAGE = '_CREATIVES_LIST_PER_PAGE'
